var _g;
import * as React from "react";
function SvgIconMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC99-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-1310.000000, -583.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Multi-color",
    transform: "translate(1120.000000, 279.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row-7",
    transform: "translate(0.000000, 304.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Media",
    transform: "translate(190.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "photo-video",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8,0 L6,0 C5.3372583,0 4.8,0.5372583 4.8,1.2 L4.8,4.8 L10.8,4.8 L10.8,2.4 L18,2.4 L18,14.4 L22.8,14.4 C23.4627417,14.4 24,13.8627417 24,13.2 L24,1.2 C24,0.5372583 23.4627417,0 22.8,0 Z M8.7,3.8625 C8.7,4.0488961 8.5488961,4.2 8.3625,4.2 L7.2375,4.2 C7.0511039,4.2 6.9,4.0488961 6.9,3.8625 L6.9,2.7375 C6.9,2.5511039 7.0511039,2.4 7.2375,2.4 L8.3625,2.4 C8.5488961,2.4 8.7,2.5511039 8.7,2.7375 L8.7,3.8625 Z M21.9,11.6625 C21.9,11.8488961 21.7488961,12 21.5625,12 L20.4375,12 C20.2511039,12 20.1,11.8488961 20.1,11.6625 L20.1,10.5375 C20.1,10.3511039 20.2511039,10.2 20.4375,10.2 L21.5625,10.2 C21.7488961,10.2 21.9,10.3511039 21.9,10.5375 L21.9,11.6625 Z M21.9,7.7625 C21.9,7.9488961 21.7488961,8.1 21.5625,8.1 L20.4375,8.1 C20.2511039,8.1 20.1,7.9488961 20.1,7.7625 L20.1,6.6375 C20.1,6.4511039 20.2511039,6.3 20.4375,6.3 L21.5625,6.3 C21.7488961,6.3 21.9,6.4511039 21.9,6.6375 L21.9,7.7625 Z M21.9,3.8625 C21.9,4.0488961 21.7488961,4.2 21.5625,4.2 L20.4375,4.2 C20.2511039,4.2 20.1,4.0488961 20.1,3.8625 L20.1,2.7375 C20.1,2.5511039 20.2511039,2.4 20.4375,2.4 L21.5625,2.4 C21.7488961,2.4 21.9,2.5511039 21.9,2.7375 L21.9,3.8625 Z",
    id: "Shape",
    fill: "#98A6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6,6 L1.2,6 C0.5372583,6 0,6.5372583 0,7.2 L0,18 C0,18.6627417 0.5372583,19.2 1.2,19.2 L15.6,19.2 C16.2627417,19.2 16.8,18.6627417 16.8,18 L16.8,7.2 C16.8,6.5372583 16.2627417,6 15.6,6 Z M3.6,8.4 C4.2627417,8.4 4.8,8.9372583 4.8,9.6 C4.8,10.2627417 4.2627417,10.8 3.6,10.8 C2.9372583,10.8 2.4,10.2627417 2.4,9.6 C2.4,8.9372583 2.9372583,8.4 3.6,8.4 Z M14.4,16.8 L2.4,16.8 L2.4,15.6 L4.8,13.2 L6,14.4 L10.8,9.6 L14.4,13.2 L14.4,16.8 Z",
    id: "Shape",
    fill: "#4C69BA"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedia);
export default __webpack_public_path__ + "static/media/icon-media.72ad1191.svg";
export { ForwardRef as ReactComponent };